import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DownloadIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.2635 4H12.7365V13.1257L16.9401 8.94012L18 10L12 16L6 10L7.05988 8.94012L11.2635 13.1257V4Z'
            />
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 16.2143H5.32857V19H18.1714V16.2143H19.5V20.2143H4V16.2143Z'
            />
        </>
    ),
})

DownloadIcon.displayName = 'DownloadIcon'
